import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Content } from 'ionic-angular';
import { CoDiscoverComponent } from '../../components/co-discover/co-discover';
import { AppState } from '../../config/state';
import { AppScreen } from '../../providers/config/config';


/**
 * Generated class for the DiscoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-discover',
  templateUrl: 'discover.html',
})
export class DiscoverPage {
  @ViewChild(Content) content: Content;
  @ViewChild('discover') private discover: CoDiscoverComponent;
  private clock: boolean;
  private screenData: AppScreen;
  viewType: any;
  menuSide: string = "left";
  isRootPage: boolean = false;
  enableBackButton: boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams, private state: AppState) {
    this.viewType = this.state.mode;
    this.menuSide = this.state.burgerMenu.menuSide;
    this.screenData = this.navParams.data.screenData;
    // console.log(this.navParams)
    this.clock = this.state.clockEnabledOnScreen;
    this.navCtrl.length() <= 1 ? this.isRootPage = true : this.isRootPage = false;
    this.navCtrl.length() <= 0 ? this.enableBackButton = false : this.enableBackButton = true;
  }
  scrollHandler(){
    this.discover.update();
  }
  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/discover/discover.ts